import React, { useCallback, useMemo } from 'react'
import Equals from 'fast-deep-equal'
import Editor from '@monaco-editor/react'
import { Button, Dialog, Dialogs } from '@leverege/ui-elements'

import S from './style.css'

let KEY = 0

export default function JSONView( props ) {
  const { deviceData, controller, opts = {} } = props
  // const value = JSON.stringify( deviceData, null, 2 )
  const [ newValue, setNewValue ] = React.useState( JSON.stringify( deviceData, null, 2 ) )
  const [ revertCount, setRevertCount ] = React.useState( 0 )
  const [ changed, setChanged ] = React.useState( false )

  const onSetValue = opts.onSetValue || controller.onSetValue

  const onOkay = useCallback( ( e ) => {
    let v
    try {
      v = JSON.parse( newValue )
    } catch ( ex ) {
      const onClose = Dialogs.show( {
        component : Dialog.Message,
        props : {
          title : 'Invalid JSON',
          message : 'The JSON object is invalid',
          onClose : () => { onClose() }
        }
      } )
      return
    }
    const onClose = Dialogs.show( {
      component : Dialog.Question,
      props : {
        title : 'Manually Update Device Data',
        okay : 'Update',
        message : 'Make sure your values are in the correct form. Mismatches may cause indexing errors. Are you sure you want to set the entire device data?',
          
        onOkay : ( e ) => {    
          const pathValue = makePathValue( deviceData, v )
          onSetValue( { attribute : null, path : pathValue, value : v } )
          setChanged( false )
          onClose()
        }, 
        onCancel : () => { onClose() }
      }
    } )

  }, [ newValue, deviceData, onSetValue ] )

  const onRevert = useCallback( ( e ) => {
    setRevertCount( () => revertCount + 1 )
    setChanged( () => false )
  }, [ revertCount, setRevertCount ] )

  const onChange = useCallback( ( e ) => {
    setChanged( () => true )
    setNewValue( () => e )
  }, [ setChanged ] )

  const [ key, value ] = useMemo( () => {
    return [ KEY++, JSON.stringify( deviceData, null, 2 ) ]
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ deviceData, revertCount ] )

  return (
    <div className={S.jsonView}>
      <Editor
        key={key}
        options={{
          minimap : {
            enabled : false
          }
        }}
        width="100%"
        defaultLanguage="json"
        value={value}
        onChange={onChange}
        theme="light" />
      <div className={S.jsonViewButtons}>
        <Button variant="primary" disabled={!changed} onClick={onOkay}>Update</Button>
        <Button variant="secondary" disabled={!changed} onClick={onRevert}>Revert</Button>
      </div>
    </div>
  )
}

function makePathValue( currValue, newValue ) {

  const obj = {}
  Object.keys( currValue || {} ).forEach( ( key ) => {
    obj[key] = null
  } )
  Object.keys( newValue || {} ).forEach( ( key ) => {
    obj[key] = newValue[key]
  } )
  const rtn = []
  Object.keys( obj ).forEach( ( key ) => {
    if ( !Equals( obj[key], currValue[key] ) ) {
      rtn.push( { path : key, value : obj[key] } )
    }
  } )
  return rtn
}
